import { render, staticRenderFns } from "./PlayerControlsButtonPrev.vue?vue&type=template&id=185a3d44&"
import script from "./PlayerControlsButtonPrev.vue?vue&type=script&lang=js&"
export * from "./PlayerControlsButtonPrev.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports